import React, { useEffect, useState } from "react";
import { motion } from "framer-motion";
import { useApp } from "@/context/AppProvider";
import { Languages } from "lucide-react";

const scrollTo = (id) => {
  const el = document.getElementById(id);
  if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
};

export const Navbar = () => {
  const { tr, toggleLang, lang } = useApp();
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const links = [
    { id: "about", label: tr.nav.about },
    { id: "experience", label: tr.nav.experience },
    { id: "impact", label: tr.nav.impact },
    { id: "projects", label: tr.nav.projects },
    { id: "certifications", label: tr.nav.certifications },
  ];

  return (
    <motion.header
      data-testid="navbar"
      initial={{ y: -80, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      transition={{ duration: 0.8, delay: 0.2, ease: [0.22, 1, 0.36, 1] }}
      className={`fixed top-0 inset-x-0 z-50 transition-[background,box-shadow,padding] duration-500 ${
        scrolled ? "glass shadow-soft py-3" : "py-6"
      }`}
    >
      <nav className="container-lux flex items-center justify-between">
        <button
          data-testid="nav-logo"
          onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
          className="font-display text-xl tracking-tight"
          style={{ color: "var(--ink)" }}
        >
          Ali<span style={{ color: "var(--gold)" }}>.</span>Inkis
        </button>

        <div className="hidden lg:flex items-center gap-9">
          {links.map((l) => (
            <button
              key={l.id}
              data-testid={`nav-${l.id}`}
              onClick={() => scrollTo(l.id)}
              className="font-body text-sm tracking-wide relative group"
              style={{ color: "var(--ink-soft)" }}
            >
              {l.label}
              <span className="absolute -bottom-1 start-0 h-[1px] w-0 group-hover:w-full transition-all duration-300" style={{ backgroundColor: "var(--gold)" }} />
            </button>
          ))}
        </div>

        <div className="flex items-center gap-3">
          <button
            data-testid="lang-toggle"
            onClick={toggleLang}
            className="flex items-center gap-2 rounded-full px-4 py-2 text-sm font-body font-medium transition-colors duration-300"
            style={{ border: "1px solid var(--gold)", color: "var(--ink)" }}
          >
            <Languages size={15} style={{ color: "var(--gold)" }} />
            {tr.nav.langLabel}
          </button>
          <button
            data-testid="nav-contact"
            onClick={() => scrollTo("contact")}
            className="hidden sm:inline-flex rounded-full px-5 py-2 text-sm font-body font-medium text-white transition-transform duration-300 hover:scale-[1.03]"
            style={{ backgroundColor: "var(--ink)" }}
          >
            {tr.nav.contact}
          </button>
        </div>
      </nav>
    </motion.header>
  );
};
